import { TradingDocumentItem } from "api/trading-documents/models";

export const getMaximumDisplayPosition = (items: TradingDocumentItem[]): number => {
  return items.reduce((max, item) => {
    return item.displayPosition > max ? item.displayPosition : max;
  }, -Infinity);
};
